
































import { defineComponent, PropType } from '@nuxtjs/composition-api'
import { Filters, SelectedFilter } from '~/models/statistics/types'
import FilterGroup from '~/components/plot/price-trends/FilterGroup.vue'
import { defineComponentTranslations } from '~/utils/i18n'

export default defineComponent({
  components: {
    FilterGroup
  },
  props: {
    filters: {
      type: Object as PropType<Filters>,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    }
  },
  setup(_, { emit }) {
    const changeFilter = (data: SelectedFilter) => {
      emit('change-filter', {
        type: data.type,
        value: data.value
      })
    }
    return {
      changeFilter
    }
  },
  i18n: defineComponentTranslations({
    areas: {
      en: 'Square meters',
      el: 'Τετραγωνικά'
    }
  })
})
